module.exports = __webpack_public_path__ + "img/android.953ac9f5.svg";